/*
 * Native Gardeners — accessibility round 7 (November 2, 2026)
 * Product image lightbox (PhotoSwipe, snippets/photoswipe-template.liquid)
 *
 *   49  Dialog name and modal semantics (also set in the Liquid markup; set here as a fallback)   WCAG 4.1.2
 *   50  Text alternative on the enlarged images (copied from the matching gallery image)            WCAG 1.1.1
 *   51  Keyboard focus stays inside the lightbox while it is open                                   WCAG 2.4.3
 *   52  Focus returns to the control that opened the lightbox when it closes                        WCAG 2.4.3
 *
 * No PhotoSwipe or theme code is changed; the script watches the lightbox element and adds the
 * behaviour on top. Loaded after a11y-round5.js from layout/theme.liquid.
 *
 * Added the same afternoon, second block below:
 *   53  Desktop navigation menus open on request, not on keyboard focus                             WCAG 2.4.3
 */
(function () {
  'use strict';

  var pswp = document.querySelector('.pswp');
  if (!pswp) return;

  var GALLERY = '.product__photos, .product__thumbs, .product-single__photos, .product__main-photos';
  var opener = null;      // element to return focus to when the lightbox closes
  var lastFocus = null;   // last element focused outside the lightbox
  var wasOpen = false;

  function productTitle() {
    var h = document.querySelector('.product-single__title, h1');
    return h ? h.textContent.replace(/\s+/g, ' ').trim() : '';
  }

  /* 49 — name and modal semantics */
  if (!pswp.getAttribute('aria-label') && !pswp.getAttribute('aria-labelledby')) {
    pswp.setAttribute('aria-label', 'Product image gallery');
  }
  pswp.setAttribute('aria-modal', 'true');

  function isOpen() {
    return pswp.classList.contains('pswp--open');
  }

  function pathOf(url) {
    if (!url) return '';
    try { return new URL(url, window.location.href).pathname; }
    catch (e) { return String(url).split('?')[0].split('#')[0]; }
  }

  /* 50 — find the alt text of the gallery image that the enlarged image was made from */
  function galleryAltFor(src) {
    var p = pathOf(src);
    if (!p) return '';
    var nodes = document.querySelectorAll('img.photoswipe__image, [data-photoswipe-src]');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var candidates = [el.getAttribute('data-photoswipe-src'), el.getAttribute('src'), el.getAttribute('data-src')];
      for (var j = 0; j < candidates.length; j++) {
        if (candidates[j] && pathOf(candidates[j]) === p) {
          var img = el.tagName === 'IMG' ? el : el.querySelector('img');
          var alt = img ? img.getAttribute('alt') : null;
          if (alt && alt.trim()) return alt.trim();
        }
      }
    }
    return '';
  }

  function labelImages() {
    var imgs = pswp.querySelectorAll('img.pswp__img');
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      var src = img.getAttribute('src') || '';
      if (img.getAttribute('data-a11y-src') === src && img.getAttribute('alt')) continue;
      var title = productTitle();
      var alt = galleryAltFor(src) || (title ? title + ' — enlarged image' : 'Enlarged product image');
      img.setAttribute('alt', alt);
      img.setAttribute('data-a11y-src', src);
    }
  }

  function visible(el) {
    if (el.disabled || el.getAttribute('aria-hidden') === 'true') return false;
    var cs = window.getComputedStyle(el);
    return cs.display !== 'none' && cs.visibility !== 'hidden';
  }

  function tabbables() {
    var nodes = pswp.querySelectorAll('button, a[href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
    var out = [];
    for (var i = 0; i < nodes.length; i++) {
      if (visible(nodes[i])) out.push(nodes[i]);
    }
    return out;
  }

  /* 51 — keep Tab and Shift+Tab inside the lightbox while it is open */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab' || !isOpen()) return;
    var items = tabbables();
    if (!items.length) return;
    var first = items[0];
    var last = items[items.length - 1];
    var active = document.activeElement;
    if (!pswp.contains(active)) {
      e.preventDefault();
      (e.shiftKey ? last : first).focus();
    } else if (e.shiftKey && (active === first || active === pswp)) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && active === last) {
      e.preventDefault();
      first.focus();
    }
  }, true);

  document.addEventListener('focusin', function (e) {
    if (!pswp.contains(e.target)) lastFocus = e.target;
  });

  function focusable(el) {
    if (!el || !document.contains(el) || typeof el.focus !== 'function') return false;
    if (!visible(el)) return false;
    return el.offsetParent !== null || window.getComputedStyle(el).position === 'fixed';
  }

  function zoomButton() {
    var buttons = document.querySelectorAll('.is-selected .js-photoswipe__zoom, .js-photoswipe__zoom');
    for (var i = 0; i < buttons.length; i++) {
      if (focusable(buttons[i])) return buttons[i];
    }
    return buttons[0] || null;
  }

  function tryFocus(el) {
    if (!focusable(el)) return false;
    try { el.focus({ preventScroll: true }); } catch (e) { el.focus(); }
    return document.activeElement === el;
  }

  /* The theme may re-select a product slide after the lightbox closes, which hides the zoom
     button of the slide that opened it; try the opener first, then the zoom button of the
     slide that is selected now, and repeat once or twice if the first attempt is too early. */
  function restoreFocus(target) {
    if (tryFocus(target)) return true;
    var buttons = document.querySelectorAll('.is-selected .js-photoswipe__zoom, .js-photoswipe__zoom');
    for (var i = 0; i < buttons.length; i++) {
      if (tryFocus(buttons[i])) return true;
    }
    return false;
  }

  function onOpen() {
    opener = (lastFocus && document.contains(lastFocus) && lastFocus.closest && lastFocus.closest(GALLERY)) ? lastFocus : zoomButton();
    labelImages();
  }

  /* 52 — return focus when the lightbox closes */
  function onClose() {
    var target = (opener && document.contains(opener)) ? opener : zoomButton();
    opener = null;
    var delays = [0, 250, 600];
    for (var i = 0; i < delays.length; i++) {
      window.setTimeout(function () {
        if (isOpen()) return;
        var active = document.activeElement;
        if (active && active !== document.body && !pswp.contains(active)) return; // focus already somewhere useful
        restoreFocus(target);
      }, delays[i]);
    }
  }

  var observer = new MutationObserver(function (records) {
    var open = isOpen();
    if (open && !wasOpen) { wasOpen = true; onOpen(); }
    else if (!open && wasOpen) { wasOpen = false; onClose(); }
    if (!open) return;
    for (var i = 0; i < records.length; i++) {
      var r = records[i];
      if (r.type === 'childList' || (r.type === 'attributes' && r.attributeName === 'src')) {
        labelImages();
        break;
      }
    }
  });
  observer.observe(pswp, { attributes: true, attributeFilter: ['class', 'src'], childList: true, subtree: true });
})();

/*
 * 53 — Desktop navigation: keyboard focus no longer opens a drop-down menu (added November 2, 2026, pm).
 *
 * The theme's hover menu (theme.js, hoverMenu) opens a menu's <details> on focusin, so Tab onto "Shop
 * Natives" opened its submenu and the next 29 Tab presses walked every submenu link on the site before
 * reaching Collections, Blog, Search and Cart; and because the theme turns any click on the <summary> into a
 * visit to the menu's own page, Enter or Space on a focused summary left the page instead of opening the
 * menu. This is ¶ 36(d) of the complaint EALG filed on October 29, 2026 ("expands automatically when it
 * receives focus, forcing blind users to navigate through all submenu elements").
 *
 * Now: a menu opens on hover for the mouse, as before, and a mouse click on its title still visits the
 * title's page. For the keyboard and for screen readers, each title is an ordinary disclosure control:
 * Tab moves across the titles with every menu closed; Enter or Space (or Down Arrow) opens the focused
 * menu, and Enter or Space closes it again; the first link inside the open menu is the title's own page
 * (shown only while it has focus, so nothing changes visually); Escape closes (item 8, round 1); the menu
 * closes when focus leaves it (theme). The same applies to second-level menus. WCAG 2.4.3, 2.1.1, 4.1.2.
 */
(function () {
  'use strict';

  function keyboardFocus(el) {
    try { return el.matches(':focus-visible'); } catch (e) { return document.activeElement === el; }
  }

  function hovered(el) {
    try { return el.matches(':hover'); } catch (e) { return false; }
  }

  /* The title's own page as the first link of the menu, visible only while focused. */
  function addParentLink(det, summary) {
    if (det.querySelector('.a11y-nav-parent')) return;
    var href = summary.getAttribute('data-link');
    var title = (summary.textContent || '').replace(/\s+/g, ' ').trim();
    if (!href || !title) return;
    var link = document.createElement('a');
    link.href = href;
    link.textContent = title;
    var col = det.querySelector('.megamenu__col');
    var list = det.querySelector('ul');
    var wrap;
    if (col) {
      link.className = 'a11y-nav-parent site-nav__dropdown-link site-nav__dropdown-link--top-level site-nav__dropdown-link--mega';
      wrap = document.createElement('div');
      wrap.className = 'megamenu__col-title a11y-nav-parent-wrap';
      wrap.appendChild(link);
      col.insertBefore(wrap, col.firstChild);
    } else if (list) {
      link.className = 'a11y-nav-parent site-nav__dropdown-link';
      wrap = document.createElement('li');
      wrap.className = 'a11y-nav-parent-wrap';
      wrap.appendChild(link);
      list.insertBefore(wrap, list.firstChild);
    }
  }

  function setup(det) {
    var summary = det.querySelector('summary');
    if (!summary) return;
    det.setAttribute('data-a11y-nav', '1');
    var keyOpenUntil = 0;

    addParentLink(det, summary);

    /* The theme opens the menu inside its focusin handler. Close it again, before the browser paints,
       unless the visitor asked for it with the keyboard or the pointer is over the menu. */
    new MutationObserver(function () {
      if (!det.hasAttribute('open')) return;
      if (Date.now() < keyOpenUntil) return;
      if (hovered(det)) return;
      if (document.activeElement !== summary || !keyboardFocus(summary)) return;
      det.removeAttribute('open');
    }).observe(det, { attributes: true, attributeFilter: ['open'] });

    /* A click that did not come from a pointer (Enter, Space, or a screen reader's activate command has
       detail 0) toggles the menu, which is the summary's own behaviour; the theme's click handler, which
       would visit the title's page, does not see it. A pointer click is left to the theme. */
    det.addEventListener('click', function (e) {
      if (e.target !== summary && !summary.contains(e.target)) return;
      if (e.detail !== 0) return;
      e.stopPropagation();
      keyOpenUntil = Date.now() + 1000;
    }, true);

    summary.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowDown' && e.key !== 'Down') return;
      e.preventDefault();
      e.stopPropagation();
      keyOpenUntil = Date.now() + 1000;
      det.setAttribute('open', '');
      var first = det.querySelector('a[href]');
      if (first) {
        first.focus();
        if (document.activeElement !== first) { window.setTimeout(function () { first.focus(); }, 60); }
      }
    });
  }

  function run() {
    var items = document.querySelectorAll('details.site-nav__details[data-hover="true"]:not([data-a11y-nav])');
    for (var i = 0; i < items.length; i++) setup(items[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
  /* The header is re-rendered in the theme editor; pick up new menus if that happens. */
  document.addEventListener('shopify:section:load', run);
})();
